import { AnalysisBatchSample, SequenceEntity } from '@/interfaces';
import { convertStringArrayToEnumLikeObject } from '@/utils';
import { flatten } from 'lodash';
import { AnalysisSampleKitEntity } from '.';
import { IncidentEntity } from './incident';

const PIPELINE_TYPES_WITH_PROGRESS = [
  'FASTQ_QC_SAMPLE_1',
  'FASTQ_QC_SAMPLE_2',
  '16S_PIPELINE',
  'PDF_GENERATE_V5',
  'PDF_QC_V5',
  'SHOTGUN_METAPHLAN_V3',
  'SHOTGUN_HUMANN_V3',
  'SHOTGUN_V1',
  'FMT_PDF_GENERATE_V1',
] as const;

const PIPELINE_TYPES_STANDALONE = [
  'B2C_SCORE_FILE',
  'TAXA_FILE',
  'ASV_FILE',
  'LDA_FILE',
  'DADA2_TRACK_FILE',
  'PATHWAY_FILE',
  'PHYLUM_FILE',
] as const;

type BaseProgress = (typeof PIPELINE_TYPES_WITH_PROGRESS)[number];
type BaseStandalone = (typeof PIPELINE_TYPES_STANDALONE)[number];

export type PipelineType =
  | BaseStandalone
  | `${BaseProgress}_START`
  | `${BaseProgress}_COMPLETE`;

export const PIPELINE_TYPES = convertStringArrayToEnumLikeObject([
  ...PIPELINE_TYPES_STANDALONE,
  ...flatten(
    PIPELINE_TYPES_WITH_PROGRESS.map(p => [`${p}_START`, `${p}_COMPLETE`]),
  ),
] as PipelineType[]);

export type PipelineHistoryOutputAndError = {
  message?: string | Record<string, any>;
  details?: Record<string, any>;
  files?: Record<string, any>;
};

export type PipelineHistoryEntity = {
  id: string;
  error: PipelineHistoryOutputAndError;
  output: PipelineHistoryOutputAndError;
  type: PipelineType;
  pipelineEntity: PipelineEntity;
  incidents?: IncidentEntity[];
};
export type PipelineEntity = {
  pipelineHistories: PipelineHistoryEntity[];
  sequence?: SequenceEntity;
  analysisSample?: AnalysisBatchSample;
  analysisSampleKit?: AnalysisSampleKitEntity;
};
